import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.span`
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    font-variation-settings:
        'FILL' 0,
        'wght' 300,
        'GRAD' 0,
        'opsz' 20;
    vertical-align: middle;
    line-height: 1;
    color: inherit;
`;

interface MaterialIconProps {
    name: string;
    className?: string;
}

const MaterialIcon: React.FC<MaterialIconProps> = ({ name, className }) => {
    return <StyledIcon className={className}>{name}</StyledIcon>;
};

export default MaterialIcon;

/**
 * Maps legacy SVG icon names (from IconManager / server treeMenu)
 * to Material Symbols Outlined icon names.
 */
export const iconNameToMaterial: Record<string, string> = {
    home_solid: 'home',
    inventory_2: 'inventory_2',
    print_solid: 'print',
    money_bill_wave_solid: 'local_offer',
    cube_solid: 'visibility',
    list_alt_solid: 'shopping_cart',
    store_alt_solid: 'storefront',
    swatchbook_solid: 'style',
    sparkles: 'auto_awesome',
    cog_solid: 'settings',
    cogs_solid: 'settings',
    tools_solid: 'tune',
    bell_solid: 'notifications',
    globe_europe_solid: 'language',
    user_alt_solid: 'account_circle',
    key_solid: 'key',
    users_solid: 'group',
    user_tie_solid: 'person',
    pencil_ruler_solid: 'edit',
    tshirt_solid: 'checkroom',
    cart_arrow_down_solid: 'shopping_cart',
    shopping_cart_solid: 'shopping_cart',
    file_invoice_solid: 'receipt_long',
    file_image: 'image',
    file_csv_solid: 'description',
    file_archive: 'folder_zip',
    folder_plus_solid: 'create_new_folder',
    icons_solid: 'category',
    fill_drip_solid: 'palette',
    sliders_h_solid: 'tune',
    table_solid: 'table_chart',
    terminal_solid: 'terminal',
    th_list_solid: 'list',
    server_solid: 'dns',
    signature_solid: 'draw',
    portrait_solid: 'portrait',
    quote_left_solid: 'format_quote',
    comment: 'chat_bubble',
    comment_dots: 'chat',
    comments_dollar_solid: 'paid',
    credit_card: 'credit_card',
    coins_solid: 'monetization_on',
    book_open_solid: 'menu_book',
    grip_horizontal_solid: 'drag_indicator',
    cubes_solid: 'view_in_ar',
    shapes_solid: 'shapes',
    chart_bar_solid: 'bar_chart',
    mail_bulk_solid: 'campaign',
    icon_3d_rotation: '3d_rotation',
    'tags-solid': 'sell',
    robot_2: 'smart_toy',
    wand_stars: 'auto_fix_high',
    question_circle_solid: 'help',
    info_circle_solid: 'info',
    envelope: 'mail',
    customizable_products_menu_icon: 'inventory_2',
    arrow_left_solid: 'arrow_back',
    arrow_right_solid: 'chevron_right',
    angle_right_solid: 'chevron_right',
    times_solid: 'close',
    'pdf-preview': 'picture_as_pdf',
    'window-restore': 'open_in_new'
};

/**
 * Given a legacy icon name from the server, return the Material Symbols name.
 * Falls back to the legacy name itself if no mapping is found.
 */
export const getMaterialIconName = (legacyName: string): string => {
    return iconNameToMaterial[legacyName] || legacyName;
};
